@if (colorFamilies() && colorFamilies().length > 0) {
  <div class="grid">
    @for (color of colorFamilies(); track color.id) {
      <div [class]="customStyle() ?? defaultStyle">
        <ppg-color-family-switcher-item
          [colorFamily]="color"
          [isSelected]="color.id === selectedColorFamily()?.id"
          (colorFamilyClick)="onColorFamilySelected($event)">
        </ppg-color-family-switcher-item>
      </div>
    }
  </div>
}
